import GenericModal from '../modals/GenericModal';

const HELP_ARTICLE_URL =
  'https://help.getthera.com/en/articles/10908526-how-to-set-up-two-factor-authentication-2fa-on-thera-using-an-authenticator-app';

const TOTPInstructionsModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => (
  <GenericModal
    open={open}
    onClose={onClose}
    title="How to set up your authenticator app"
    width="w-[30rem]"
    dialogClass="relative z-50"
    showHeaderBorder={false}
  >
    <ol className="list-decimal space-y-4 pl-4 text-sm text-neutral-500">
      <li>
        <p className="font-medium text-neutral-900">Download an authenticator app</p>
        <p>
          On your phone, install Google Authenticator, Microsoft Authenticator or Authy from the Google Play Store or
          the Apple App Store. Any authenticator app works.
        </p>
      </li>
      <li>
        <p className="font-medium text-neutral-900">Add your Thera account to the app</p>
        <p>
          Open the app, tap <span className="font-medium">Add account</span> or <span className="font-medium">+</span>,
          then scan the QR code shown on this page. If you cannot scan it (for example, you are already on your phone),
          choose <span className="font-medium">Enter a setup key</span> instead and paste the setup key you copied from
          Thera.
        </p>
      </li>
      <li>
        <p className="font-medium text-neutral-900">Enter the 6-digit code</p>
        <p>
          Your authenticator app now shows a 6-digit code for Thera that changes every 30 seconds. Type that code into
          Thera and click Verify. Thera does not send this code by email or SMS.
        </p>
      </li>
      <li>
        <p className="font-medium text-neutral-900">Save your recovery codes</p>
        <p>
          Recovery codes are a backup for when you lose access to your phone. They are not the 6-digit code, so keep
          them somewhere safe and do not use them to verify this setup.
        </p>
      </li>
    </ol>
    <p className="mt-4 text-sm text-neutral-500">
      Still stuck? Read the{' '}
      <a href={HELP_ARTICLE_URL} target="_blank" rel="noopener noreferrer" className="underline">
        full guide
      </a>{' '}
      or contact us at{' '}
      <a href="mailto:support@getthera.com" className="underline">
        support@getthera.com
      </a>
      .
    </p>
  </GenericModal>
);

export default TOTPInstructionsModal;
